const env = (process.env.REACT_APP_STAGE || 'local') as 'local' | 'staging' | 'production';

const payBaseByEnv: Record<typeof env, string> = {
    local: 'http://localhost:3004/pay/',
    staging: 'https://web.ogatepay.com/pay/',
    production: 'https://ogateway.io/pay/',
};

const config = {
    env,
    dbpref: 'persist:',
    server: process.env.REACT_APP_API_URL || 'http://localhost:3001/',
    version: require('../../package.json').version,
    sentry_dns: process.env.REACT_APP_SENTRY_DNS || '',
    pay_base: payBaseByEnv[env],
};

export default config;